import React, { useState } from 'react'
import { convertDate, declOfNum } from '@helpers/site'
import ModalWindow from '@shared/ModalWindow/ModalWindow'
import PropTypes from 'prop-types'
import { DeliveryStatusType, PriceType } from 'src/consts'
import SymbolRuble from '@shared/SymbolRuble/SymbolRuble'
import * as S from './GoodPriceDescription.styled'
import { useOpenStockForGoods } from 'src/features/shipment-selector/hooks'

const getPriceItem = (
    isAvailable,
    isDeliveryPrice,
    price,
    availableStocksCount,
    isSelectedStock,
    clickHandlerDeliveryReasons,
    clickOpenAnotherStockHandler,
    isSelectedAddress,
    isAvailableDeliveryByErecipe
) => {
    const getAnotherStockDescription = () => {
        if (availableStocksCount) {
            return (
                <S.AnotherStockCountDescription onClick={clickOpenAnotherStockHandler}>
                    Нет в выбранной, самовывоз из {availableStocksCount}{' '}
                    {declOfNum(availableStocksCount, ['аптеки', 'аптек', 'аптек'])}
                </S.AnotherStockCountDescription>
            )
        }
        return <S.AnotherStockCountDescription>Нет в выбранной</S.AnotherStockCountDescription>
    }

    if ((isDeliveryPrice && !isAvailable && !isAvailableDeliveryByErecipe) || !price.normal) {
        return (
            <S.PriceItemContainer>
                <S.PriceItem>
                    <S.ShipmentTitle onClick={clickHandlerDeliveryReasons}>
                        Доставка <S.DeliveryStatusTitle>невозможна</S.DeliveryStatusTitle>
                    </S.ShipmentTitle>
                </S.PriceItem>
            </S.PriceItemContainer>
        )
    }

    if (!isDeliveryPrice && !availableStocksCount && !price.normal) {
        return (
            <S.PriceItemContainer>
                <S.PriceItem>
                    <S.ShipmentTitle>
                        Самовывоз <S.AnotherStockCountDescription>Нет в наличии</S.AnotherStockCountDescription>
                    </S.ShipmentTitle>
                </S.PriceItem>
            </S.PriceItemContainer>
        )
    }

    // noinspection JSCheckFunctionSignatures
    return (
        <S.PriceItemContainer>
            <S.PriceItem>
                {!isAvailable && isSelectedStock ? (
                    getAnotherStockDescription()
                ) : (
                    <S.ShipmentTitle>
                        {isDeliveryPrice ? 'Доставка' : 'Самовывоз'}{' '}
                        {(!price.isDemand && isSelectedAddress && isDeliveryPrice) ||
                        (!price.isDemand && !isDeliveryPrice)
                            ? 'сегодня'
                            : ''}
                        {isDeliveryPrice && isAvailableDeliveryByErecipe ? (
                            <S.DeliveryStatusTitle> по рецепту </S.DeliveryStatusTitle>
                        ) : (
                            <React.Fragment />
                        )}
                        {price.isDemand && <S.DateRed>{convertDate(price.aptEtaDateTime)}</S.DateRed>}
                    </S.ShipmentTitle>
                )}
                {price.withoutPromo && isAvailable ? (
                    <S.PriceBlock>
                        <S.PriceDataOld>
                            {price.withoutPromo.toLocaleString('RU-ru')} <SymbolRuble />
                        </S.PriceDataOld>
                        <S.PriceNumberSaleBold>
                            {price.normal.toLocaleString('RU-ru')} <SymbolRuble />
                        </S.PriceNumberSaleBold>
                    </S.PriceBlock>
                ) : (
                    <S.PriceBlock>
                        {!isAvailable && !isDeliveryPrice ? (
                            <S.PriceSumFrom onClick={clickOpenAnotherStockHandler}>
                                от {price.normal?.toLocaleString('RU-ru')} <SymbolRuble />
                            </S.PriceSumFrom>
                        ) : (
                            <S.PriceSum>
                                {price.normal?.toLocaleString('RU-ru')} <SymbolRuble />
                            </S.PriceSum>
                        )}
                    </S.PriceBlock>
                )}
            </S.PriceItem>
        </S.PriceItemContainer>
    )
}

const GoodPriceDescription = (props) => {
    const openStockForGoods = useOpenStockForGoods()
    const isDeliveryAvl = props.deliveryStatus?.isAvailableForDelivery || props.isAvailableDeliveryByErecipe
    // noinspection DuplicatedCode
    const priceFroStock = props.isAvailableOnStock ? props.stockPrice : props.minPrice

    const [deliveryReasonState, setDeliveryReasonState] = useState({
        isShowedModal: false,
        reasons: []
    })
    const openDeliveryReasons = (reasons) => {
        setDeliveryReasonState({
            ...deliveryReasonState,
            isShowedModal: true,
            reasons
        })
    }
    const closeDeliveryReasons = () => {
        setDeliveryReasonState({
            ...deliveryReasonState,
            isShowedModal: false,
            reasons: []
        })
    }

    const clickHandlerDeliveryReasons = () => {
        openDeliveryReasons(
            props.deliveryStatus.reasons.map((reason) => ({
                id: reason.deliveryReasonID,
                text: reason.warningText
            }))
        )
    }
    // noinspection JSValidateTypes
    return (
        <S.Container>
            {deliveryReasonState.isShowedModal && (
                <ModalWindow
                    title="Внимание"
                    isMobile
                    isButtonFooter={false}
                    isFooterOnlyOneButton
                    cancel={{
                        text: 'Понятно',
                        clickHandler: closeDeliveryReasons
                    }}>
                    <S.ReasonContainer>
                        {deliveryReasonState.reasons.map((reason) => (
                            <S.ReasonTextItem key={reason.id} dangerouslySetInnerHTML={{ __html: reason.text }} />
                        ))}
                    </S.ReasonContainer>
                </ModalWindow>
            )}

            {getPriceItem(
                props.isAvailableOnStock,
                false,
                priceFroStock,
                props.availableStocksCount,
                props.isSelectedStock,
                () => {},
                () => openStockForGoods([props.goodId]),
                false,
                props.isAvailableDeliveryByErecipe
            )}
            {getPriceItem(
                isDeliveryAvl,
                true,
                props.deliveryPrice,
                props.availableStocksCount,
                props.isSelectedStock,
                clickHandlerDeliveryReasons,
                () => openStockForGoods([props.goodId]),
                !!props.shipment.shipAddressId,
                props.isAvailableDeliveryByErecipe
            )}
        </S.Container>
    )
}

GoodPriceDescription.propTypes = {
    isSelectedStock: PropTypes.bool.isRequired,
    availableStocksCount: PropTypes.number,
    isAvailableOnStock: PropTypes.bool.isRequired,
    isAvailableDeliveryByErecipe: PropTypes.bool,
    deliveryStatus: PropTypes.shape(DeliveryStatusType).isRequired,
    deliveryPrice: PropTypes.shape(PriceType).isRequired,
    stockPrice: PropTypes.shape(PriceType).isRequired,
    minPrice: PropTypes.shape(PriceType).isRequired,
    shipment: PropTypes.object.isRequired,
    goodId: PropTypes.number.isRequired
}
GoodPriceDescription.defaultProps = {
    availableStocksCount: 0
}

export default GoodPriceDescription
